'use strict';

/**
 * This creates a directive to remove elements (not) in specific contexts. This will create directives:
 * ms-core-only
 * ms-youth-only
 * ms-profile-only
 * ms-not-youth
 *
 * If these directives are applied to an element, and we're in (or not in) that context, the element will be removed.
 *
 * This is to make our widget HTML compatible across all of our different contexts, without the need for new templates.
 */
(function () {
  'use strict';
  // create a directive for each of the contexts
  // Syntax: 'directiveName': directiveDeclaration()

  var allContextDirectives = {
    'msCoreOnly': onlyDirective('core'),
    'msNotCore': exceptDirective('core'),
    'msYouthOnly': onlyDirective('youth'),
    'msNotYouth': exceptDirective('youth'),
    'msProfileOnly': onlyDirective('profile'),
    'msNotProfile': exceptDirective('profile'),
    'msOnlyReferrals': onlyDirective('referrals'),
    'msNotReferrals': exceptDirective('referrals'),
    'msOnlyOnboarding': onlyDirective('onboarding'),
    'msNotOnboarding': exceptDirective('onboarding')
  };

  _.forEach(allContextDirectives, function (directive, directiveName) {
    directive.$inject = ['context'];
    angular.module('msCore').directive(directiveName, directive);
  });

  /**
   * This builds a directive that will remove an element when it's not in the specified context
   * @param  {String} requiredContext The context in which the element will be allowed to exist
   * @return {Directive}              The directive that will remove the element if not in that context
   */
  function onlyDirective(requiredContext) {
    return function (context) {
      var directive = {
        link: link,
        restrict: 'A',
        scope: false
      };
      return directive;

      function link(scope, element) {
        if (context !== requiredContext) {
          element.remove();
        }
      }
    };
  }
  /**
   * This builds a directive that will remove an element when it's in the specified context
   * @param  {String} exceptContext The context in which the element will be not allowed to exist
   * @return {Directive}            The directive that will remove the element if in that context
   */
  function exceptDirective(exceptContext) {
    return function (context) {
      var directive = {
        link: link,
        restrict: 'A',
        scope: false
      };
      return directive;

      function link(scope, element) {
        if (context === exceptContext) {
          element.remove();
        }
      }
    };
  }
})();